import { useFeatureIsOn } from '@growthbook/growthbook-react';

export const SERVICE_ANALYSE_FEATURE_FLAG = 'feature.vpd.serviceanalyse-overview';

export const useServiceAnalyseEnabled = (): boolean => useFeatureIsOn(SERVICE_ANALYSE_FEATURE_FLAG);
